// Built-in default layouts — used by LayoutRenderer when the resolver returns
// `{layout: null}` (i.e. the workspace has not authored a custom layout for
// this category, or the layout endpoint is not deployed yet in Phase L1).
//
// The `*.builtin` widgets are pass-through wrappers that delegate to the
// existing CaseClient surfaces via the `callbacks.renderBuiltin` ctx hook.
// This guarantees byte-equivalence with today's UI on workspaces that have
// authored zero layouts.
//
// BUILTIN_VERSION is bumped when any built-in tree's *shape* changes. The
// "Updates available" banner in the Designer (L4) compares this against the
// version embedded in customer-authored trees on Publish.

export const BUILTIN_VERSION = 1;

export const BUILTIN_HOME = Object.freeze({
  id: 'root',
  type: 'home.builtin',
  config: {},
  children: [],
});

export const BUILTIN_CASE = Object.freeze({
  id: 'root',
  type: 'case.builtin',
  config: {},
  children: [],
});

export const BUILTIN_TASK = Object.freeze({
  id: 'root',
  type: 'task.builtin',
  config: {},
  children: [],
});

export const BUILTIN_ADD_CASE = Object.freeze({
  id: 'root',
  type: 'add_case.builtin',
  config: {},
  children: [],
});

export const BUILTIN_ADD_TASK = Object.freeze({
  id: 'root',
  type: 'add_task.builtin',
  config: {},
  children: [],
});

export const BUILTIN_LAYOUTS = Object.freeze({
  home: BUILTIN_HOME,
  case: BUILTIN_CASE,
  task: BUILTIN_TASK,
  add_case: BUILTIN_ADD_CASE,
  add_task: BUILTIN_ADD_TASK,
});
